import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { withNamespaces } from 'react-i18next';

/**
 * Component to display variant options tab content with navigation to list view
 * @param {Object} props - Component props
 * @returns {JSX.Element} VariantOptionsTab component
 */
const VariantOptionsTab = (props) => {
  const { detectChangesIndividualTab, t } = props;
  const history = useHistory();
  const { lng } = useParams();
  
  useEffect(() => {
    // Reset change detection when component mounts
    if (detectChangesIndividualTab) {
      detectChangesIndividualTab(false);
    }
  }, [detectChangesIndividualTab]);
  
  const navigateToVariantOptions = () => {
    history.push(`/${lng}/settings/variant-options`);
  };
  
  return (
    <div className="container-fluid">
      <div className="row mb-4">
        <div className="col-md-12">
          <div className="d-flex justify-content-between align-items-center">
            <h4 className="page-title">{t('variantOptions.tab.title')}</h4>
            <Button 
              variant="primary"
              className="btn-sm"
              onClick={navigateToVariantOptions}
            >
              <FontAwesomeIcon icon={faPlus} className="mr-1" /> {t('variantOptions.tab.buttons.manage')}
            </Button>
          </div>
          <p className="text-muted">
            {t('variantOptions.tab.description')}
          </p>
        </div>
      </div>
      
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">{t('variantOptions.tab.about.title')}</h5>
              <p>
                {t('variantOptions.tab.about.description')}
              </p>
              <ul>
                <li><strong>{t('variantOptions.tab.about.examples.size.label')}</strong>: {t('variantOptions.tab.about.examples.size.values')}</li>
                <li><strong>{t('variantOptions.tab.about.examples.color.label')}</strong>: {t('variantOptions.tab.about.examples.color.values')}</li>
                <li><strong>{t('variantOptions.tab.about.examples.material.label')}</strong>: {t('variantOptions.tab.about.examples.material.values')}</li>
              </ul>
              <p>
                {t('variantOptions.tab.about.instruction')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withNamespaces()(VariantOptionsTab);
